import { Injectable, Injector } from "@angular/core";
import { NotificationAbstract } from "./notification-abstract";
import { ENotificationType } from "../enums/e-notification-type";
import { INotificationSendParams } from "./notification-send-param";

@Injectable({
  providedIn: 'root'
})
export class NotificationReminderSession extends NotificationAbstract {
    
    constructor(private injector : Injector){
      super();
    }

    type: ENotificationType = ENotificationType.ReminderSession;
    
    public send(NotificationSendParams: INotificationSendParams) {
      throw new Error("Method not implemented.");
    }
    public received() {
      
    }
    public perform() {
    }
}

